import { createContext, useContext, useState } from 'react';

export const SIDEBAR_COLLAPSED_WIDTH = 61;
export const SIDEBAR_EXPANDED_WIDTH = 280;

const SidebarExpansionContext = createContext<
  | {
      isExpanded: boolean;
      toggleExpanded: () => void;
    }
  | undefined
>(undefined);

export const SidebarExpansionProvider = ({ children }: { children: React.ReactNode }) => {
  const [isExpanded, setIsExpanded] = useState(() => {
    try {
      const stored = localStorage.getItem('nexus-sidebar-expanded');
      return stored !== null ? JSON.parse(stored) : true;
    } catch {
      return true;
    }
  });

  const toggleExpanded = () => {
    const newValue = !isExpanded;
    setIsExpanded(newValue);
    localStorage.setItem('nexus-sidebar-expanded', JSON.stringify(newValue));
  };

  return (
    <SidebarExpansionContext.Provider value={{ isExpanded, toggleExpanded }}>
      {children}
    </SidebarExpansionContext.Provider>
  );
};

export const useSidebarExpansionContext = () => {
  const context = useContext(SidebarExpansionContext);
  if (!context) {
    throw new Error('useSidebarExpansionContext must be used within SidebarExpansionProvider');
  }
  return context;
};
